import React from 'react';
import NativeLink from './NativeLink';

const TargetBlankLink: React.StatelessComponent<any> = props => (
    <NativeLink {...props} target="_blank" rel="noopener noreferrer" />
);

export default TargetBlankLink;
